import _ from 'lodash'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { skipToken } from '@reduxjs/toolkit/query'

import { Autocomplete, Box, Paper, TextField } from '@mui/material'

import { useGetStaffsByEstablishmentQuery } from '@/core/services/staff'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { MAIN_HEADER_HEIGHT } from '@/layouts/main'

import { AgendaScheduler } from './components/AgendaScheduler'

export default function EstablishmentAgendaPage() {
  const { t } = useTranslation()
  const authUser = useAppSelector(selectAuthUser)

  const { data: staffs } = useGetStaffsByEstablishmentQuery(authUser?.establishment?._id ?? skipToken)

  const staffOptions = useMemo(
    () =>
      staffs?.map((staff) => ({
        label: `${staff.userInfo.name} ${staff.userInfo.surname} `,
        value: staff._id,
      })) ?? [],
    [staffs]
  )

  const [selectedStaffId, setSelectedStaffId] = useState<string | null>(null)

  return (
    <Box flex={1} sx={{ maxHeight: `calc(100vh - ${MAIN_HEADER_HEIGHT}px)`, p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Paper sx={{ p: 2 }}>
        <Autocomplete
          options={staffOptions}
          renderInput={(params) => <TextField {...params} label={t('page.establishmentAgenda.staffSelector.label', 'Select a staff member')} />}
          onChange={(_, option) => setSelectedStaffId(option?.value ?? null)}
          value={staffOptions.find((opt) => opt.value === selectedStaffId) ?? null}
          fullWidth
        />
      </Paper>

      {selectedStaffId && <AgendaScheduler staffs={[selectedStaffId]} targetUserId={selectedStaffId} height="auto" />}
    </Box>
  )
}
